import { render, staticRenderFns } from "./add-structure-modal.vue?vue&type=template&id=4fa808da&scoped=true"
import script from "./add-structure-modal.vue?vue&type=script&lang=js"
export * from "./add-structure-modal.vue?vue&type=script&lang=js"
import style0 from "./add-structure-modal.vue?vue&type=style&index=0&id=4fa808da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa808da",
  null
  
)

export default component.exports